<mat-card class="reports-card" [class.collapsed]="isCollapsed" [class.simulator-card]="cardId === 'simulator'">
  <mat-card-content class="card-content">
    <!-- Header colorido com título e botão Ver Mais quando recolhido -->
    <div class="card-header" [style.background-color]="borderColor">
      <h3 class="card-title">{{ title }}</h3>
      <button
        *ngIf="isCollapsed"
        mat-button
        class="see-more-button-header"
        (click)="onSeeMoreClick(); $event.stopPropagation()"
        appTrackClick
        [trackEvent]="getTrackingEvent()"
        [trackCategory]="getTrackingCategory()"
        [trackLabel]="getTrackingLabel()">
        Ver mais
        <img src="assets/icons/blueArrowRight.png" alt="Seta" class="arrow-icon">
      </button>
    </div>

    <!-- Conteúdo (visível apenas quando expandido) -->
    <div class="content-section" *ngIf="!isCollapsed">
      <p class="card-text">{{ content }}</p>
    </div>

    <!-- Divider (visível apenas quando expandido) -->
    <mat-divider *ngIf="!isCollapsed" class="card-divider"></mat-divider>

    <!-- Botão Ver Mais alinhado à direita (visível apenas quando expandido) -->
    <div *ngIf="!isCollapsed" class="button-section">
      <button
        mat-button
        class="see-more-button"
        (click)="onSeeMoreClick()"
        appTrackClick
        [trackEvent]="getTrackingEvent()"
        [trackCategory]="getTrackingCategory()"
        [trackLabel]="getTrackingLabel()">
        Ver mais
        <img src="assets/icons/blueArrowRight.png" alt="Seta" class="arrow-icon">
      </button>
    </div>
  </mat-card-content>
</mat-card>
